import React from 'react';
import {InputField, View, ButtonFields} from 'react-template';

class Select extends View {
    constructor(props){
        super(props);
        this.deleteItem = this.deleteItem.bind(this);
        this.addItem = this.addItem.bind(this);
        this.setOpcao = this.setOpcao.bind(this);
        this.setLimiteOpcao = this.setLimiteOpcao.bind(this); 
        this.state = {opcoesIguais: false};
    }

    ehDesabilitado(id){
        //Item de Evento
        if(this.props.itemEvento){
            return true;
        //radio - 2 primeiras opcoes desabilitadas
        }else if(this.props.item.tipo === 'radio' && (id === 0 || id === 1)){
            return true;
        // checkbox e select - primeira opcao desabilitada
        }else if((this.props.item.tipo === 'checkbox' || this.props.item.tipo === 'select') && id === 0 ){
            return true;
        }
        return false;
    }

    deleteItem(opcao, e){
        e.preventDefault();
        let novasOpcoes = this.props.item.opcoes.filter(opcaoN =>
            opcaoN.id !== opcao.id
        );
        this.props.actions.updateItem({...this.props.item,
            opcoes: novasOpcoes});
        this.checkOpcoesIguais(novasOpcoes);
    }

    addItem(){
        const valor = this.props.temValor ? '0,00' : undefined
        const limite = this.props.temLimite ? 1 : undefined
        this.props.actions.updateItem({...this.props.item,
            opcoes : [...this.props.item.opcoes,
            {
                id: this.props.item.opcoes.reduce((maxId, item) => Math.max(item.id, maxId), -1) + 1,
                texto: '',
                valor: valor,
                limiteDeVagas:limite
            }]
        });
    }

    checkOpcoesIguais(op){
        let opcoes = [];
        op.forEach( opcao => {
            opcoes.push(opcao.texto);
        });
        let opcoesIguais = false;
        for (let i = 0; i < opcoes.length; i++) {
            for (let k = i + 1; k < opcoes.length; k++) {
                if (opcoes[i] !== '' && opcoes[k] !== '' && opcoes[i] === opcoes[k]) {
                    opcoesIguais = true;
                }
            }
        }
        this.setState({...this.state, opcoesIguais: opcoesIguais});
    }

    setOpcao(opcao, data){
        let novasOpcoes = this.props.item.opcoes.map(opcaoN =>
            opcaoN.id === opcao.id ?
            {...opcaoN, texto: data.value} :
            opcaoN
        );
        this.props.actions.updateItem( {...this.props.item, opcoes: novasOpcoes})
        this.checkOpcoesIguais(novasOpcoes);
    }

    setValorOpcao(opcao, data){
        this.props.actions.updateItem( {...this.props.item, opcoes: this.props.item.opcoes.map(opcaoN =>
            opcaoN.id === opcao.id ?
            {...opcaoN, valor: data.value} :
            opcaoN
        )})
    }

    setLimiteOpcao(opcao, data){
        this.props.actions.updateItem( {...this.props.item, opcoes: this.props.item.opcoes.map(opcaoN =>
            opcaoN.id === opcao.id ?
            {...opcaoN, limiteDeVagas: data.value} :
            opcaoN
        )})
    }

    getTextoValor(){
        if(this.props.itemEvento){
            return 'Valor da Incrição R$'
        }else{
            return 'Valor R$'
        }
    }

    render() {
        return (
            <div >
                {this.props.item.opcoes.map( opcao => (
                    <div key={opcao.id}>
                        <div className='m-0 p-0 width-100 select-para-valor-vaga'>
                            <div className="d-flex width-100">
                                <InputField
                                    disabled={this.props.itemEvento}
                                    style={{marginRight: 10+'px'}} 
                                    value={opcao.texto} 
                                    name={'input'+opcao.id} 
                                    required
                                    label={'Opção '+(this.props.item.opcoes.indexOf(opcao)+1).toString()} 
                                    onChange={(e, data) => this.setOpcao(opcao, data)}
                                    invalidMessage="Campo Obrigatório"                                  
                                    />

                                {opcao.valor !== undefined &&
                                    <InputField
                                        style={{marginRight: 10+'px'}} 
                                        className='money_mask' 
                                        required
                                        label={this.getTextoValor()}
                                        value={opcao.valor} 
                                        onChange={(e, data) => this.setValorOpcao(opcao, data)}
                                        invalidMessage="Campo Obrigatório"/>} 

                                {opcao.limiteDeVagas !== undefined && 
                                    <InputField
                                        style={{marginRight: 10+'px'}} 
                                        type='number' 
                                        pattern="\d*"
                                        min="1" 
                                        label='Nº de vagas' 
                                        required
                                        value={opcao.limiteDeVagas} 
                                        onChange={(e, data) => this.setLimiteOpcao(opcao, data)}
                                        invalidMessage="Campo Obrigatório"                                  

                                        />}
                                
                                <ButtonFields className="m-l-0" type="button" button="fab" icon="close" mini color="transparent" onClick={(e) => this.deleteItem(opcao, e)} disabled={this.ehDesabilitado(opcao.id)}/>
                            </div>
                        </div>
                    </div>
                ))}
                {this.state.opcoesIguais && this.getMessage("warning", "Aviso", "Os campos não podem ser iguais.")}
                <br/>

                <ButtonFields mini color="black" type="button" button="fab" icon='add' content='Adicionar novo campo' disabled={this.props.itemEvento} onClick={this.addItem}/>
            </div>
        );
    }
}

export default Select;


// WEBPACK FOOTER //
// ./src/components/formbuilder/formItensElements/Select.js